import * as React from 'react';
import { loadZendeskEmbed, openWidget, hasPersistedOpenChat } from './zendesk';
import LoadingBars from '@reverbdotcom/commons/dist/components/loading_bars';
import * as elog from '@reverbdotcom/commons/dist/elog';

function ZendeskChatIcon() {
  /* eslint-disable max-len */
  return (
    <svg viewBox="0 0 15 16">
      <path d="M1.3,16c-0.7,0-1.1-0.3-1.2-0.8c-0.3-0.8,0.5-1.3,0.8-1.5c0.6-0.4,0.9-0.7,1-1c0-0.2-0.1-0.4-0.3-0.7c0,0,0-0.1-0.1-0.1 C0.5,10.6,0,9,0,7.4C0,3.3,3.4,0,7.5,0C11.6,0,15,3.3,15,7.4s-3.4,7.4-7.5,7.4c-0.5,0-1-0.1-1.5-0.2C3.4,15.9,1.5,16,1.5,16 C1.4,16,1.4,16,1.3,16z M3.3,10.9c0.5,0.7,0.7,1.5,0.6,2.2c0,0.1-0.1,0.3-0.1,0.4c0.5-0.2,1-0.4,1.6-0.7c0.2-0.1,0.4-0.2,0.6-0.1 c0,0,0.1,0,0.1,0c0.4,0.1,0.9,0.2,1.4,0.2c3,0,5.5-2.4,5.5-5.4S10.5,2,7.5,2C4.5,2,2,4.4,2,7.4c0,1.2,0.4,2.4,1.2,3.3 C3.2,10.8,3.3,10.8,3.3,10.9z" />
    </svg>
  );
  /* eslint-enable max-len */
}

/**
 * Allows for Zendesk's chat widget to _only_ be loaded
 * when needed. We defer the loading of this widget due to
 * its impact on site performance.
 *
 * We also need to load the button in the case that there's an
 * active chat noted in localstorage. This state is currently
 * managed in zendesk.js, but can safely be moved into here
 * once the rollout of this feature is complete (DEFER_ZOPIM)
 *
 */

export function ZendeskButton() {
  const [loaded, setLoaded] = React.useState(false);
  const [clicked, setClicked] = React.useState(false);

  React.useEffect(() => {
    if (hasPersistedOpenChat()) {
      // preload if there is an ongoing chat
      setClicked(true);
    }
  }, []); // Only on mount

  React.useEffect(() => {
    if (clicked && !loaded) {
      loadZendeskEmbed()
        .then(() => {
          openWidget();
          setLoaded(true);
        })
        .catch(e => elog.error('zendesk.widget_error', {}, e));
    }
  }, [clicked, loaded]);

  if (loaded) return null;

  return (
    <div className="chat-widget">
      <button
        className="chat-widget__button"
        onClick={() => setClicked(true)}
        type="button"
      >
        <div className="chat-widget__icon">
          {(!loaded && clicked)
            ? <LoadingBars size="small" color="white" />
            : <ZendeskChatIcon />
          }
        </div>
        <span className="chat-widget__label">
          {(!loaded && clicked)
            ? I18n.t('zendesk.webWidget.helpCenter.loading')
            : I18n.t('zendesk.webWidget.helpCenter.title')
          }
        </span>
      </button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./javascripts/components/zendesk_button.jsx